import axios from "axios";

import { getAppConfigSetting } from "../../utils/getAppConfigSetting";

export interface Permission {
  permitted: boolean;
  request: {
    orgUnit: null;
    permission: string;
  };
}

export interface PermissionsResponse {
  hasAll: boolean;
  hasAny: boolean;
  permissions: Permission[];
}
const permissionsURL = `${getAppConfigSetting(
  "apiUrl"
)}/legit/api/v2/authorization`;

const formatPermissions = (permissions: string[]) => {
  return permissions.map(permission => ({
    permission,
  }));
};

export const fetchPermissions = async (
  permissions: string[]
): Promise<PermissionsResponse> => {
  try {
    const { data } = await axios.post<PermissionsResponse>(
      permissionsURL,
      formatPermissions(permissions),
      {
        withCredentials: true,
      }
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
